module.exports = __webpack_public_path__ + "static/media/hugo-boss-bottled-night-big.1cee2793.png";